import React from 'react'
import type { FlightSearchWidgetState } from './flightSearchWidgetStateReducer'
import { initialState } from './flightSearchWidgetStateReducer'

const FlightSearchWidgetStateContext = React.createContext<FlightSearchWidgetState>(initialState)

export default FlightSearchWidgetStateContext
